'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _utils = require('../utils');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var adminSection = context.getElement('.' + context.className + '_Container');
  var adminButton = context.getElement('.' + context.className + '_Button');
  var adminInput = context.getElement('.' + context.className + '_Input');
  var activeClass = 'pas-Admin-active';

  adminButton.addEventListener('click', function (e) {
    var adminOpen = adminSection.classList.contains(activeClass);

    adminSection.classList.toggle(activeClass, !adminOpen);

    if (window.innerWidth > _utils.mediaBreakpoints.md && adminOpen === false) {
      adminInput.focus();
    }
  });
}